'use strict';
module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/internals/engine-user-agent.js
// module id = 141
// module chunks = 0